import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedGrid from './components/FeaturedGrid';
import TrendingSidebar from './components/TrendingSidebar';
import LatestNews from './components/LatestNews';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="黑料社 - 独家猛料曝光平台 | 娱乐圈网红圈商业圈最新内幕"
        description="黑料社是专注独家内幕、热点曝光与深度八卦的聚合平台。第一时间获取娱乐圈、网红圈、商业圈的独家黑料，真实可信、内容劲爆，每日更新不断。"
        keywords="黑料社,黑料社最新消息,黑料社独家曝光,黑料社八卦内幕,黑料社娱乐圈,黑料社网红曝光,黑料社热点事件"
        canonicalUrl="https://heiliaoshe.com/"
        ogType="website"
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '黑料社',
          url: 'https://heiliaoshe.com/',
          description: '专注独家内幕、热点曝光与深度八卦的聚合平台',
          foundingDate: '2024',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'contact@heiliaoshe.com',
          },
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '黑料社',
          url: 'https://heiliaoshe.com/',
          description: '独家猛料曝光平台',
          inLanguage: 'zh-CN',
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '黑料社 - 首页',
          url: 'https://heiliaoshe.com/',
          isPartOf: { '@type': 'WebSite', name: '黑料社' },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedGrid />
          <TrendingSidebar />
          <LatestNews />
        </main>
        <Footer />
      </div>
    </>
  );
}